// O `foqtipo` do card de texto carrega o limite de caracteres no sufixo:
// 'card-text' (padrão 100) ou 'card-text-4000'. O componente registrado é sempre
// 'card-text', então o tipo precisa ser normalizado antes do `<component :is>`.

export const LIMITE_TEXTO_PADRAO = 100;
// Tamanho da coluna formularioresposta.forresposta na API — acima disso o banco recusa.
export const LIMITE_TEXTO_MAXIMO = 5000;

const TIPO_TEXTO = /^card-text(?:-(\d+))?$/;

// 'card-text-4000' -> 'card-text'; demais tipos passam direto.
export function componenteCard(foqtipo) {
  return TIPO_TEXTO.test(foqtipo || '') ? 'card-text' : foqtipo;
}

// Sem sufixo (ou 0) -> padrão; acima do máximo -> máximo.
export function limiteTexto(foqtipo) {
  const [, sufixo] = TIPO_TEXTO.exec(foqtipo || '') || [];
  const limite = Number(sufixo) || LIMITE_TEXTO_PADRAO;
  return Math.min(limite, LIMITE_TEXTO_MAXIMO);
}
